<style scoped="scoped" lang="scss">
//.el-table--small {
//  font-size: 12px;
//}
._form /deep/ .el-table--small {
  font-size: 14px;
}

._input /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 30px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
    <div id="export">
      <el-form ref="form" size="mini" :model="task" label-width="235px" :inline="true">
        <el-form-item :label="$t('pandiandanhao')" class="noborder">
          <el-input disabled v-model="$attrs.taskOrder.no"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pandianleixing')" class="noborder">
          <span v-if="$attrs.taskOrder.inventoryType == 0">{{ $t('ancangku') }}</span>
          <span v-if="$attrs.taskOrder.inventoryType == 1">{{ $t('ankuqu') }}</span>
          <span v-if="$attrs.taskOrder.inventoryType == 2">{{ $t('anchanpinfenlei') }}</span>
          <span v-if="$attrs.taskOrder.inventoryType == 3">{{ $t('zhidingwuliao') }}</span>
        </el-form-item>
        <el-form-item :label="$t('pandianrenyuan')" class="noborder">
          <el-input disabled v-model="$attrs.taskOrder.createByObject.nickname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pandianjiesuoshijian')" class="noborder">
          <!--        <el-input disabled v-model="dateFormat($attrs.taskOrder.startInventoryTime)"></el-input>-->
          <span>{{ $attrs.taskOrder.countUnlockTime == null ? '' : dateFormat($attrs.taskOrder.countUnlockTime) }}</span>
        </el-form-item>
        <el-form-item :label="$t('pandianzhuangtai')" class="noborder">
          <span v-if="$attrs.taskOrder.status == 0">{{ $t('dailingqu') }}</span>
          <span v-if="$attrs.taskOrder.status == 1">{{ $t('daipanidan') }}</span>
          <span v-if="$attrs.taskOrder.status == 2">{{ $t('pandianzhong') }}</span>
          <span v-if="$attrs.taskOrder.status == 3">{{ $t('daishenhe') }}</span>
          <span v-if="$attrs.taskOrder.status == 4">{{ $t('yiwancheng') }}</span>
          <span v-if="$attrs.taskOrder.status == 5">{{ $t('yizuofei') }}</span>
        </el-form-item>
      </el-form>
      <el-button v-if="$attrs.taskOrder.status == 4" @click="printContent" size="mini" style="margin-bottom: 10px" type="primary">{{ $t('dayinbiaoge') }}</el-button>
      <el-button v-if="$attrs.taskOrder.status == 4" style="float:right;" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
      <!--    <div style="margin-bottom: 10px">{{$t('pandianmingxi')}}</div>-->

      <div v-if="$attrs.taskOrder.inventoryType == 0 || $attrs.taskOrder.inventoryType == 1" style="margin-bottom: 10px" class="_form">
        <el-table id="pagetable" max-height="600" :data="task.tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" stripe :row-style="rowStyle" size="small" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', font_size: '14px' }">
          <el-table-column v-for="(item, index) in task.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :width="item.width" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-if="item.prop === 'remark'">
                <el-input disabled size="small" v-model="scope.row.remark"></el-input>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <div class="_form">
            <el-table-column :label="$t('pandianshu')" width="180">
              <template slot-scope="scope">
                <el-input-number disabled size="mini" class="_input" v-model="scope.row.inventoryCount" @change="handlerChange" :min="0"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column :label="$t('danwei')" width="180">
              <template slot-scope="scope">
                <!--        <el-input v-model="scope.row.suppliername" ></el-input>-->
                <yi_dictionary_select disabled class="_input" :type="'UNIT_CONVERSION_TYPE'" :ids.sync="scope.row.unit"> </yi_dictionary_select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('pandianjieguo')" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.inventoryResult !== null">
                  <span style="color: #67C23A" v-if="scope.row.inventoryResult == 1">{{ $t('panying') }}</span>
                  <span style="color: #F56C6C" v-if="scope.row.inventoryResult == 0">{{ $t('pankui') }}</span>
                  <span v-if="scope.row.inventoryResult == 2">{{ $t('zhengchang') }}</span>
                </span>
                <span v-else>
                  <span style="color: #67C23A" v-if="scope.row.inventoryCount - scope.row.quantityOnHand > 0">{{ $t('panying') }}</span>
                  <span style="color: #F56C6C" v-if="scope.row.inventoryCount - scope.row.quantityOnHand < 0">{{ $t('pankui') }}</span>
                  <span v-if="scope.row.inventoryCount - scope.row.quantityOnHand == 0">{{ $t('zhengchang') }}</span>
                </span>
              </template>
            </el-table-column>

            <!--          <el-table-column :label="$t('beizhu')" width="180">-->
            <!--            <template slot-scope="scope">-->
            <!--              <el-input disabled size="small" v-model="scope.row.remark"></el-input>-->
            <!--            </template>-->
            <!--          </el-table-column>-->
          </div>
        </el-table>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 10px;">
          <el-pagination v-if="task.tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="task.tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>

      <div v-if="$attrs.taskOrder.inventoryType == 2" style="margin-bottom: 10px" class="_form">
        <el-table max-height="600" :data="task.tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" stripe :row-style="rowStyle" size="small" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', font_size: '14px' }">
          <el-table-column v-for="(item, index) in task.productTableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :width="item.width" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-if="item.prop === 'remark'">
                <el-input disabled size="small" v-model="scope.row.remark"></el-input>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <div class="_form">
            <el-table-column :label="$t('pandianshu')" width="180">
              <template slot-scope="scope">
                <el-input-number disabled size="mini" class="_input" v-model="scope.row.inventoryCount" @change="handlerChange" :min="0"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column :label="$t('danwei')" width="180">
              <template slot-scope="scope">
                <yi_dictionary_select disabled class="_input" :type="'UNIT_CONVERSION_TYPE'" :ids.sync="scope.row.unit"> </yi_dictionary_select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('pandianjieguo')" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.inventoryResult !== null">
                  <span style="color: #67C23A" v-if="scope.row.inventoryResult == 1">{{ $t('panying') }}</span>
                  <span style="color: #F56C6C" v-if="scope.row.inventoryResult == 0">{{ $t('pankui') }}</span>
                  <span v-if="scope.row.inventoryResult == 2">{{ $t('zhengchang') }}</span>
                </span>
                <span v-else>
                  <span style="color: #67C23A" v-if="scope.row.inventoryCount - scope.row.quantityOnHand > 0">{{ $t('panying') }}</span>
                  <span style="color: #F56C6C" v-if="scope.row.inventoryCount - scope.row.quantityOnHand < 0">{{ $t('pankui') }}</span>
                  <span v-if="scope.row.inventoryCount - scope.row.quantityOnHand == 0">{{ $t('zhengchang') }}</span>
                </span>
              </template>
            </el-table-column>
          </div>
        </el-table>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 10px;">
          <el-pagination v-if="task.tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="task.tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
      <div v-if="$attrs.taskOrder.inventoryType == 3" style="margin-bottom: 10px" class="_form">
        <el-table max-height="600" :data="task.tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" stripe :row-style="rowStyle" size="small" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', font_size: '14px' }">
          <el-table-column v-for="(item, index) in task.materialTableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :width="item.width" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <template v-if="item.prop === 'remark'">
                <el-input disabled size="small" v-model="scope.row.remark"></el-input>
              </template>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <div class="_form">
            <el-table-column :label="$t('pandianshu')" width="180">
              <template slot-scope="scope">
                <el-input-number disabled size="mini" class="_input" v-model="scope.row.inventoryCount" @change="handlerChange" :min="0"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column :label="$t('danwei')" width="180">
              <template slot-scope="scope">
                <!--        <el-input v-model="scope.row.suppliername" ></el-input>-->
                <yi_dictionary_select disabled class="_input" :type="'UNIT_CONVERSION_TYPE'" :ids.sync="scope.row.unit"> </yi_dictionary_select>
              </template>
            </el-table-column>
            <el-table-column :label="$t('pandianjieguo')" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.inventoryResult !== null">
                  <span style="color: #67C23A" v-if="scope.row.inventoryResult == 1">{{ $t('panying') }}</span>
                  <span style="color: #F56C6C" v-if="scope.row.inventoryResult == 0">{{ $t('pankui') }}</span>
                  <span v-if="scope.row.inventoryResult == 2">{{ $t('zhengchang') }}</span>
                </span>
                <span v-else>
                  <span style="color: #67C23A" v-if="scope.row.inventoryCount - scope.row.quantityOnHand > 0">{{ $t('panying') }}</span>
                  <span style="color: #F56C6C" v-if="scope.row.inventoryCount - scope.row.quantityOnHand < 0">{{ $t('pankui') }}</span>
                  <span v-if="scope.row.inventoryCount - scope.row.quantityOnHand == 0">{{ $t('zhengchang') }}</span>
                </span>
              </template>
            </el-table-column>
          </div>
        </el-table>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 10px;">
          <el-pagination v-if="task.tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="task.tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import print from 'print-js';
export default {
  name: 'chect_list',
  data() {
    return {
      tableHeight: 0,
      // inventoryCountChange: null,
      // resultStatus: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        orderId: this.$attrs.taskOrder.id
      },

      task: {
        tableData: [],
        tableColumn: [
          {
            label: 'cangkumingcheng',
            prop: 'warehouseName',
            width: 150,
            sortable: false
          },
          {
            label: 'kuqumingcheng',
            prop: 'warehouseAreaName',
            width: 150,
            sortable: false
          },
          {
            label: 'kuweimingcheng',
            prop: 'warehouseLocationName',
            width: 150,
            sortable: false
          },
          {
            label: 'wuliaobianma',
            prop: 'materialCode',
            width: 150,
            sortable: false
          },
          {
            label: 'wuliaomingcheng',
            prop: 'materialName',
            width: 150,
            sortable: false
          },
          {
            label: 'jibenfenlei',
            prop: 'materialType',
            width: 150,
            sortable: false
          },
          {
            label: 'chanpinfenlei',
            prop: 'materialValue',
            width: 150,
            sortable: false
          },
          {
            label: 'kucunxiancunliang',
            prop: 'quantityOnHand',
            width: 150,
            sortable: false
          },
          // {
          //   label: 'danwei',
          //   prop: 'materialname',
          //   sortable: false,
          // },{
          //   label: 'pandianshu',
          //   prop: 'materialname',
          //   sortable: false,
          // },
          // {
          //   label: 'pandianjieguo',
          //   prop: 'inventoryResult',
          //   sortable: false,
          // },
          {
            label: 'beizhu',
            prop: 'remark',
            width: 150,
            sortable: false
          }
        ],
        productTableColumn: [
          {
            label: 'chanpinfenlei',
            prop: 'materialValue',
            width: 150,
            sortable: false
          },
          {
            label: 'wuliaobianma',
            prop: 'materialCode',
            width: 150,
            sortable: false
          },
          {
            label: 'wuliaomingcheng',
            prop: 'materialName',
            width: 150,
            sortable: false
          },
          {
            label: 'jibenfenlei',
            prop: 'materialType',
            width: 150,
            sortable: false
          },
          {
            label: 'cangkumingcheng',
            prop: 'warehouseName',
            width: 150,
            sortable: false
          },
          {
            label: 'kuqumingcheng',
            prop: 'warehouseAreaName',
            width: 150,
            sortable: false
          },
          {
            label: 'kuweimingcheng',
            prop: 'warehouseLocationName',
            width: 150,
            sortable: false
          },
          {
            label: 'kucunxiancunliang',
            prop: 'quantityOnHand',
            width: 150,
            sortable: false
          },
          {
            label: 'beizhu',
            prop: 'remark',
            width: 150,
            sortable: false
          }
        ],
        materialTableColumn: [
          {
            label: 'wuliaobianma',
            prop: 'materialCode',
            width: 150,
            sortable: false
          },
          {
            label: 'wuliaomingcheng',
            prop: 'materialName',
            width: 150,
            sortable: false
          },
          {
            label: 'jibenfenlei',
            prop: 'materialType',
            width: 150,
            sortable: false
          },
          {
            label: 'chanpinfenlei',
            prop: 'materialValue',
            width: 150,
            sortable: false
          },
          {
            label: 'cangkumingcheng',
            prop: 'warehouseName',
            width: 150,
            sortable: false
          },
          {
            label: 'kuqumingcheng',
            prop: 'warehouseAreaName',
            width: 150,
            sortable: false
          },
          {
            label: 'kuweimingcheng',
            prop: 'warehouseLocationName',
            width: 150,
            sortable: false
          },
          {
            label: 'kucunxiancunliang',
            prop: 'quantityOnHand',
            width: 150,
            sortable: false
          },
          {
            label: 'beizhu',
            prop: 'remark',
            width: 150,
            sortable: false
          }
        ]
      }
    };
  },
  watch: {
    '$attrs.taskOrder.id': {
      handler(n, o) {
        if (n) {
          this.getInt();
        }
        console.log('vvvvvv', n);
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // setTimeout(() => {
    //   this.getInt()
    // }, 300)
  },
  mounted() {
    // console.log('task.tableDatadd',this.task.tableData)
  },
  methods: {
    dateFormat(time) {
      // return "333"
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },
    exportExcel() {
      let params = {
        id: this.$attrs.taskOrder.id
      };
      return this.http
        .get('/web/report/export/warehouse_inventory', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // 导出图片
    printContent() {
      //在页面显示需打印区域来获取dom
      // html2canvas(document.getElementById('export')).then((canvas)
      html2canvas(document.getElementById('export')).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '盘点单任务',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          // footer: "My Footer Text"
        });
      });
      // print({
      //   printable: 'export',
      //   type: 'image',
      //   header: null,
      //   imageStyle: `display: block;margin: 0 auto;page-break-after: always;max-width:100%`,
      //   scanStyles: false
      // })
      // html2canvas(document.getElementById('export')).then((canvas) => {
      //   const doc = new jsPDF("landscape");
      //   doc.addImage(canvas.toDataURL("image/png"), "PNG", 10, 10, 280, 180);
      //   doc.save("盘点单任务.pdf");
      // });
      // 使用print-js库打印组件中的内容
    },
    handlerChange(e) {
      // this.inventoryCountChange = e
      console.log('bbllllll', e);
    },
    async getInt() {
      let params = {
        warehouseInventoryId: this.$attrs.taskOrder.id,
        pageNum: 1,
        pageSize: 10
      };
      return await this.http
        .get('/web/warehouse/inventory/getItemById', {
          params
        })
        .then(res => {
          this.task.tableData = res.data;
          if (this.task.tableData.length > 0) {
            // 盘点结果(0=盘亏,1=盘盈,2=正常)
            for (let i = 0; i < this.task.tableData.length; i++) {
              this.task.tableData[i]['materialValue'] = this.task.tableData[i]['materialValue'] == (null || undefined) ? '' : this.store.state.dictJsonAll['GYLXCPFL'][this.task.tableData[i]['materialValue']];
              this.task.tableData[i]['materialType'] = this.task.tableData[i]['materialType'] == (null || undefined) ? '' : this.$t(this.store.state.dictJsonAll['CUSTOMER_MATERIAL_TYPE'][this.task.tableData[i]['materialType']]);
              // this.inventoryCountChange
              //quantityOnHand
              // if(this.inventoryCountChange){
              //   this.resultStatus = this.inventoryCountChange-this.task.tableData[i]['quantityOnHand']
              // }
              console.log('inventoryResult', this.resultStatus);
              // this.task.tableData[i]['inventoryResult'] =  this.task.tableData[i]['inventoryResult']==0?this.$t('pankui'):
              //     this.task.tableData[i]['inventoryResult']==1?this.$t('panying'):this.task.tableData[i]['inventoryResult']==2?this.$t('zhengchang'):''
            }
          }
          console.log('this.tableDatas', res);
          // this.$message.success(this.$t(res.msg))
          // this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },
    // 行样式
    rowStyle({ row, rowIndex }) {
      let style = {
        height: '30px'
      };
      let rowStartUpValue = parseFloat(row.startupRateValue);
      let inputSartUpValue = this.startUpRate ? parseFloat(this.startUpRate) : 0.0;
      if (rowStartUpValue < inputSartUpValue) {
        style['background'] = '#FEF0F0';
        style['color'] = '#000';
      }
      let rowRunValue = parseFloat(row.runRateValue);
      let inputRunValue = this.jiadongRate !== undefined ? parseFloat(this.jiadongRate) : 0.0;
      if (rowRunValue < inputRunValue) {
        style['background'] = '#FEF0F0';
        style['color'] = '#000';
      }
      return style;
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    handleDelete(index, row) {
      console.log(index, row);
    }
  }
};
</script>
